// extracted by mini-css-extract-plugin
module.exports = {"list":"QuoteList_list__1iJcF","sorting":"QuoteList_sorting__2TE3_"};